import dayjs from 'dayjs';
import dayjstz from '@/helpers/dayjstz';
import getCurrentTimeZone from '@/helpers/getCurrentTimeZone';

const dateFormat = 'L LT';

function dayjsAdapter(date, c) {
    let newDate = dayjs(date, c);

    if (typeof date === 'string') {
        if (newDate.format(dateFormat) !== 'Invalid Date') {
            newDate = dayjstz(newDate.format(dateFormat), dateFormat, getCurrentTimeZone());
        }
    } else {
        newDate = dayjstz(date, c, getCurrentTimeZone());
    }

    return newDate;
}

dayjsAdapter.unix = function (timestamp) {
    return dayjstz.unix(timestamp);
};

dayjsAdapter.subtract = function (date, amount, unit) {
    return dayjstz(
        dayjs(date.format(dateFormat)).subtract(amount, unit).format(dateFormat),
        dateFormat,
        getCurrentTimeZone()
    );
};

dayjsAdapter.startOf = function (date, unit) {
    return dayjstz(
        dayjs(date.format(dateFormat)).startOf(unit).format(dateFormat),
        dateFormat,
        getCurrentTimeZone()
    );
};

dayjsAdapter.endOf = function (date, unit) {
    return dayjstz(
        dayjs(date.format(dateFormat)).endOf(unit).format(dateFormat),
        dateFormat,
        getCurrentTimeZone()
    );
};

dayjsAdapter.fromNow = function (date) {
    return dayjstz(date).fromNow();
};

dayjsAdapter.format = function (date, format) {
    return dayjstz(date).format(format);
};

dayjsAdapter.isSameDay = function (date1, date2) {
    return dayjstz(date1).isSame(dayjstz(date2), 'day');
};

dayjsAdapter.utc = function (date) {
    return dayjstz.utc(date);
};

dayjsAdapter.isValid = function (date) {
    return dayjstz(date).isValid();
};

dayjsAdapter.tz = function (date, timezone) {
    return dayjstz(date, timezone);
};

dayjsAdapter.tz.guess = function () {
    return getCurrentTimeZone();
};

dayjsAdapter.isBetween = function (date, start, end) {
    return dayjstz(date).isBetween(start, end);
};

dayjsAdapter.isAfter = function (date, start) {
    return dayjstz(date).isAfter(start);
};

dayjsAdapter.isBefore = function (date, end) {
    return dayjstz(date).isBefore(end);
};

dayjsAdapter.isSameOrAfter = function (date, start) {
    return dayjstz(date).isSameOrAfter(start);
};

dayjsAdapter.isSameOrBefore = function (date, end) {
    return dayjstz(date).isSameOrBefore(end);
};

dayjsAdapter.isSame = function (date, other) {
    return dayjstz(date).isSame(other);
};

dayjsAdapter.valueOf = function (date) {
    return dayjstz(date).valueOf();
};

dayjsAdapter.diff = function (date, unit, float) {
    return dayjstz.diff(date, unit, float);
};

dayjsAdapter.clone = function (date) {
    return dayjstz(date).clone();
};

dayjsAdapter.week = function (date) {
    return dayjstz(date).week();
};

dayjsAdapter.day = function (date, day) {
    return dayjstz(date).day(day);
};

export default dayjsAdapter;
